const isVideo = (url: string): boolean => {
  // 확장자를 가져옴
  const extension = url.split('.').pop()?.toLowerCase();

  // 비디오 파일 확장자 목록
  const videoExtensions = [
    'mp4',
    'mov',
    'avi',
    'mkv',
    'flv',
    'wmv',
    'webm',
    'quicktime'
  ];

  // 확장자가 비디오 확장자 목록에 포함되어 있는지 확인
  return videoExtensions.includes(extension || '');
};

export default isVideo;
